const COTTAGE = "https://images.unsplash.com/photo-1575403071235-5dcd06cbf169?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3b29kZW4lMjBjb3R0YWdlJTIwbmF0dXJlfGVufDB8fHx8MTc4NjYxNzI3M3ww&ixlib=rb-4.1.0&q=85";

export function CottageSection() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
      <img src={COTTAGE} alt="Modern cottage" className="w-full max-h-[420px] object-cover rounded-lg border border-border" />
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground font-semibold">For plot owners</div>
        <h2 className="heading text-3xl md:text-4xl font-semibold mt-4">Your weekend cottage, without the WhatsApp mess.</h2>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Reserve your cottage stays with real-time conflict detection. If a plot is under active high-priority maintenance, the platform stops the booking before it happens.
        </p>
        <ul className="mt-6 space-y-2 text-sm">
          <li className="flex gap-2"><span className="text-primary">•</span> Overlap-safe reservations with clear conflict messages</li>
          <li className="flex gap-2"><span className="text-primary">•</span> Owner-only booking on their plots — no cross-booking</li>
          <li className="flex gap-2"><span className="text-primary">•</span> Manager approval workflow (pending → confirmed)</li>
        </ul>
      </div>
    </section>
  );
}
